import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import OpenStreetMapPicker from './OpenStreetMapPicker';

const iconOptions = ['🎤', '🎭', '🎪', '🏟', '⚽', '🏉', '🏏', '🎾', '🚴', '🎫', '📍', '🛍', '🍽', '🌙'];
const ICON_BY_CATEGORY = { sports: '🏟', concerts: '🎤', festivals: '🎪', community: '📍' };

const pickIcon = (category) => ICON_BY_CATEGORY[String(category || '').toLowerCase()] || '🎫';

const classifySize = (attendance) => {
  if (attendance < 2000) return 'local';
  if (attendance < 10000) return 'event';
  if (attendance < 50000) return 'main';
  return 'major';
};

const getLeavingWindow = (size, end) => {
  const windows = { local: [-5, 10], event: [-10, 15], main: [-15, 20], major: [-20, 30] };
  const [before, after] = windows[size];
  const endTime = new Date(end).getTime();
  return {
    leaving_start: new Date(endTime + before * 60000).toISOString(),
    leaving_end: new Date(endTime + after * 60000).toISOString()
  };
};

export default function AddEventModal({ onAdd, onClose }) {
  const [form, setForm] = useState({
    title: '',
    category: 'concerts',
    start_local: '',
    true_end: '',
    attendance: 0,
    phq_attendance: 0,
    icon: '🎤',
    venue_name: '',
    postcode: '',
    venue_formatted_address: '',
    lat: '',
    lon: ''
  });

  const update = (name, value) => setForm((current) => ({ ...current, [name]: value }));

  const submit = (event) => {
    event.preventDefault();
    if (!form.title || !form.venue_name || !form.start_local || !form.true_end) return;

    const attendance = Number(form.attendance) || 0;
    const trueEnd = new Date(form.true_end).toISOString();
    const size = classifySize(attendance);
    const normalized = {
      ...form,
      id: uuid(),
      start_local: new Date(form.start_local).toISOString(),
      true_end: trueEnd,
      attendance,
      phq_attendance: Number(form.phq_attendance) || attendance,
      lat: form.lat !== '' ? Number(form.lat) : null,
      lon: form.lon !== '' ? Number(form.lon) : null,
      icon: form.icon || pickIcon(form.category),
      size,
      ...getLeavingWindow(size, trueEnd),
      check_timings: '',
      flag: false,
      labels: []
    };

    onAdd(normalized);
  };

  return <div className="modal-overlay" onClick={onClose}><form className="modal" onSubmit={submit} onClick={(e) => e.stopPropagation()}><div className="modal-heading"><div><span className="eyebrow">MANUAL ENTRY</span><h2>Add event</h2></div><button type="button" className="close" onClick={onClose}>×</button></div><div className="modal-grid"><label>Title<input required value={form.title} onChange={(e) => update('title', e.target.value)} /></label><label>Category<select value={form.category} onChange={(e) => { const nextCategory = e.target.value; update('category', nextCategory); update('icon', pickIcon(nextCategory)); }}><option>concerts</option><option>sports</option><option>festivals</option><option>community</option><option>other</option></select></label><label>Icon<select value={form.icon} onChange={(e) => update('icon', e.target.value)}>{iconOptions.map((icon) => <option key={icon} value={icon}>{icon}</option>)}</select></label><label>Start<input required type="datetime-local" value={form.start_local} onChange={(e) => update('start_local', e.target.value)} /></label><label>End<input required type="datetime-local" value={form.true_end} onChange={(e) => update('true_end', e.target.value)} /></label><label>Venue<input required value={form.venue_name} onChange={(e) => update('venue_name', e.target.value)} /></label><label>Attendance<input type="number" min="0" value={form.attendance} onChange={(e) => update('attendance', Number(e.target.value) || 0)} /></label><label>Postcode<input value={form.postcode} onChange={(e) => update('postcode', e.target.value)} /></label><label>Address<textarea rows="2" value={form.venue_formatted_address} onChange={(e) => update('venue_formatted_address', e.target.value)} /></label></div><OpenStreetMapPicker lat={form.lat || 51.5074} lon={form.lon || -0.1278} onChange={(lat, lon) => setForm((current) => ({ ...current, lat, lon }))} /><div className="coordinate-grid"><label>Latitude<input type="number" step="0.000001" value={form.lat} onChange={(e) => update('lat', e.target.value)} /></label><label>Longitude<input type="number" step="0.000001" value={form.lon} onChange={(e) => update('lon', e.target.value)} /></label></div><div className="modal-actions"><button type="button" className="button muted" onClick={onClose}>Cancel</button><button type="submit" className="button primary">Add event</button></div></form></div>;
}
